"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Score = void 0;
const constants_1 = require("@daytrip/constants");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const SCORE_CONFIG = {
    feedbacksAverage: {
        min: 1,
        max: 5,
    },
};
let Score = class Score {
    totalScore = constants_1.INITIAL_DRIVER_SCORE_RATING;
    feedbacksAverage;
    ratingStartDate;
    // This field might be removed when it's no longer needed for monitoring
    updatedAt;
    tier;
    cancellationRateInfo;
};
exports.Score = Score;
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => (value >= 0 ? value : constants_1.INITIAL_DRIVER_SCORE_RATING)),
    __metadata("design:type", Number)
], Score.prototype, "totalScore", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(SCORE_CONFIG.feedbacksAverage.min),
    (0, class_validator_1.Max)(SCORE_CONFIG.feedbacksAverage.max),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Score.prototype, "feedbacksAverage", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], Score.prototype, "ratingStartDate", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], Score.prototype, "updatedAt", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Score.prototype, "tier", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], Score.prototype, "cancellationRateInfo", void 0);
exports.Score = Score = __decorate([
    (0, class_transformer_1.Exclude)()
], Score);
//# sourceMappingURL=Score.js.map